import { Injectable } from '@angular/core';
import { BehaviorSubject, scan } from 'rxjs';

export interface Message {
  user_id: string;
  text: string;
  room_id: string;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  private _messages$ = new BehaviorSubject<Message | Message[]>([]);
  private readonly maxMessages = 300;

  messages$ = this._messages$.pipe(
    scan((acc, curr: Message | Message[]) => {
      if (Array.isArray(curr)) {
        return curr.slice(-this.maxMessages);
      } else {
        return [...acc, curr].slice(-this.maxMessages);
      }
    }, [] as Message[])
  );

  loadMessages(messages: Message[]) {
    this._messages$.next(messages);
  }

  addMessage(message: Message) {
    this._messages$.next(message);
  }
}
